import React, { FC, useEffect, useMemo, useState } from 'react'
import { KTSVG, useDebounce } from '../../../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import './ReportCss.scss'
import {
  GetCampaignRepliesData,
  GetReportId,
  getCampaignReplies,
} from '../reportSlices/reportAnalytics'
import moment from 'moment-timezone'
import QuickMessageDrawerInner from '../../../../../_metronic/partials/layout/drawer-messenger/Quickmessge'
import ReactPaginate from 'react-paginate'
import NodataYet from '../../../../Components/NodataYet'
import { AuthenticateUser } from '../../../../Utils/_helpers/RoleAndPermission'
import { ENV } from '../../../../Utils/_helpers/EnvHelper'
import { Button, Modal, OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap'
import { getIsDefaultRegion } from '../../accounts/Overview/OverviewSlice/UserDetailsSlice'
import { useFetchReportPaginateListGroupQuery } from '../../../../../services/cellcast.v3'
import Select from 'react-select'
import { ContactStatusOptions } from '../Common'
import { useSubscribeContactMutation, useUnSubscribeContactMutation } from '../../../../../services/cellcast'
import { toast } from 'react-toastify'
import AssignedTags from '../../Contacts/AllContactsList/Modal/AssignedTags'

type ImageModalProps = {
  show: boolean
  url: string
  onClose: () => void
}
const ImageModal: FC<ImageModalProps> = (props) => {
  const { show, url, onClose } = props

  return (
    <Modal show={show} onHide={onClose}>
      <Modal.Body>
        <div className='card-header'>
          <div className='card-title'>
            <h2 className='text-center'>Image Preview</h2>
          </div>
          <div className='card-toolbar align-items-center'></div>
        </div>
        <div className='card-body p-0'>
          <img src={url} alt='Preview' style={{ width: '100%', height: 'auto' }} />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

const CustomerReplies = () => {
  const dispatch = useDispatch()
  const API_DOMAIN = ENV().REACT_APP_DOMAIN

  const isDefaultRegion = useSelector(getIsDefaultRegion)
  const ReportId = useSelector(GetReportId)
  const RepliesData = useSelector(GetCampaignRepliesData)
  const [openQuickMessage, setOpenQuickMessage] = useState(false)
  const [number, setNumber] = useState({ id: '', number: '', ReportId: '' })
  const [search, setSearch] = useState({
    searchValue: '',
    page: 1,
  })
  const [loading, setLoading] = useState(false)
  const [contactStatus, setContactStatus] = useState<string | undefined>('subscribe')

  const [showImageUrl, setImageUrl] = useState('')
  const [showImageModal, setShowImageModal] = useState(false)

  const debouncedSearchTerm = useDebounce(search.searchValue, 300)
  const params: any = { camp_type: ReportId?.camp_type, ...search }

  const [showAddTagModal, setShowAddTagModal] = useState(false)
  const [selectedContactIDs, setSelectedContactIDs] = useState<string[]>([])

  useEffect(() => {
    if (contactStatus) {
      params.status = contactStatus
    }
    setLoading(true)
    dispatch(
      getCampaignReplies({ id: ReportId?.id, params })
    )
      .finally(() => {
        setLoading(false)
      })
  }, [debouncedSearchTerm, search, contactStatus])

  const { data: messageListRegion, isLoading: isLoadingMessageListRegion } =
    useFetchReportPaginateListGroupQuery(
      {
        page: search.page,
        limit: 10,
        scope: 'reply',
        messageType: 'sms',
        type: 'message',
        group: 'metadata.contactId',
        bulkId: ReportId?.id,
      },
      {
        skip: isDefaultRegion,
      }
    )

  const ImagePreviewModal = useMemo(
    () => (
      <ImageModal
        show={showImageModal}
        url={showImageUrl}
        onClose={() => {
          setShowImageModal(false)
          setImageUrl('')
        }}
      />
    ),
    [showImageModal, showImageUrl]
  )

  const [subscribeContact, {isLoading: subscribeLoading}] = useSubscribeContactMutation()
  const [unsubscribeContact, {isLoading: isUnsubscribeLoading}] = useUnSubscribeContactMutation()

  const onClickSubscribeHandler = (id: any) => {
    subscribeContact({contactIDs: [id]})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)
          setLoading(true)

          if (contactStatus) {
            params.status = contactStatus
          }

          dispatch(
            getCampaignReplies({ id: ReportId?.id, params})
          ).finally(() => {
              setLoading(false)
          })
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error subscribe:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }

  const onClickUnsubscribeHandler = (id: any) => {
    unsubscribeContact({contactIDs: [id]})
      .then((res) => {
        if ('data' in res) {
          toast.success(res.data?.message)

          if (contactStatus) {
            params.status = contactStatus
          }      
          dispatch(
            getCampaignReplies({ id: ReportId?.id, params })
          ).finally(() => {
              setLoading(false)
          })
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error unsubscribe:', res.error)
        }
      })
      .catch((err: any) => {
        toast.error(err.error)
      })
  }

  const AddTagModal = useMemo(
    () => (
      <AssignedTags
        checkList={selectedContactIDs}
        show={showAddTagModal}
        handleClose={() => setShowAddTagModal(false)}
        callbackFn={(result: any) => {
          if (result?.status === 200) {
            toast.success(result.data?.message)
          } else {
            toast.error(result.data?.message ?? 'Something went wrong')
          }
          dispatch(
            getCampaignReplies({ id: ReportId?.id, params, status: contactStatus })
          ).finally(() => {
              setLoading(false)
          })
          setSelectedContactIDs([])
        }}
      />
    ),
    [showAddTagModal, selectedContactIDs]
  )

  const renderDefaultRegion = () => {
    return (
      <>
        {AddTagModal}
        {loading ? (
          <div className='card-body pt-2 mx-auto'>
            <Spinner />
          </div>
        ) : RepliesData?.data?.items?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-5'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Mobile</th>
                      <th>First Name</th>
                      <th>Full Name</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Customer Reply</th>
                      <th>Your Reply</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {RepliesData?.data?.items?.map((key: any, i: number) => {
                      return (
                        <tr key={i} className='border-dashed border-1 border-bottom'>
                          <td>{key?.mobile}</td>
                          <td>
                            {key?.fields?.find(
                              (key: any) =>
                                key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                            )
                              ? key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'firstname'
                              )?.value
                              : '-'}
                          </td>
                          <td>
                            {key?.fields?.find(
                              (key: any) =>
                                key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                            )
                              ? key?.fields?.find(
                                (key: any) =>
                                  key?.name?.toLowerCase()?.replace(/ +/g, '') === 'fullname'
                              )?.value
                              : '-'}
                          </td>
                          <td>{moment(key?.customerResponseAt)?.format('l')}</td>
                          <td>{moment(key?.customerResponseAt)?.format('LT')}</td>

                          <td className='top-align'>
                            <div className='message-display'>{key.customerResponse || '-'}</div>
                            {key.customerResponseMedia &&
                              Array.isArray(key.customerResponseMedia) &&
                              key.customerResponseMedia.length > 0 && (
                                <>
                                  <br />
                                  <Button
                                    size='sm'
                                    className='btm btn-sm mt-5'
                                    onClick={() => {
                                      setImageUrl(
                                        key.customerResponseMedia
                                          ? key.customerResponseMedia[0].url
                                          : ''
                                      )
                                      setShowImageModal(true)
                                    }}
                                  >
                                    Show Image
                                  </Button>
                                </>
                              )}
                          </td>
                          <td className='top-align'>
                            <div className='message-display'>{key?.userReplied || '-'}</div>
                            {key?.userRepliedMedia &&
                              Array.isArray(key.userRepliedMedia) &&
                              key.userRepliedMedia.length > 0 && (
                                <>
                                  <br />
                                  <Button
                                    size='sm'
                                    className='btm btn-sm mt-5'
                                    onClick={() => {
                                      setImageUrl(
                                        key.userRepliedMedia
                                          ? key.userRepliedMedia[0].url
                                          : ''
                                      )
                                      setShowImageModal(true)
                                    }}
                                  >
                                    Show Image
                                  </Button>
                                </>
                              )}
                          </td>
                          <td>
                            <span
                              className={
                                key?.isBlocked === true || key?.isBlockedByUser === true
                                  ? 'badge badge badge-light-danger fw-bold  fs-7  badge-square p-4  py-5' :  'badge badge-light-success green_text_badge badge-square p-4  py-5'
                              }
                            >
                              {key?.isBlocked === true || key?.isBlockedByUser === true
                                ? 'Unsubscribed' : 'Subscribed'}
                            </span>
                          </td>
                          <td>
                            <div className='d-flex gap-2 justify-content-end'>
                              {key?.isReplied ? (
                                <button className='btn btn-sm btn-light-success btn-active-light-primary fw-500'>
                                  Replied
                                </button>
                              ) : (
                                <button
                                  onClick={() => {
                                    setNumber({ id: key?._id, number: key?.mobile, ReportId })
                                    setOpenQuickMessage(true)
                                  }}
                                  style={{ backgroundColor: '#F6F8FA', color: '#A2A5B5' }}
                                  className='btn btn-sm btn-light-success  fw-500'
                                >
                                  Reply
                                </button>
                              )}
                              {key?.isBlocked === true || key?.isBlockedByUser === true
                                ? (
                                  <OverlayTrigger
                                      placement='bottom'
                                      delay={{show: 250, hide: 400}}
                                      overlay={<Tooltip id='tooltip-bottom'>Subscribe</Tooltip>}
                                    >
                                      <span
                                        className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                        onClick={() => {
                                          onClickSubscribeHandler(key?.contactId ?? key?._id)
                                        }}
                                      >
                                        {key.contactId && subscribeLoading ? (
                                          <Spinner />
                                        ) : (
                                          AuthenticateUser('edit-contact') && (
                                            <i className='bi bi-person-fill-add fs-5 text-success'></i>
                                          )
                                        )}
                                      </span>
                                  </OverlayTrigger>
                                ) : (
                                  <OverlayTrigger
                                      placement='bottom'
                                      delay={{show: 250, hide: 400}}
                                      overlay={<Tooltip id='tooltip-bottom'>Unsubscribe</Tooltip>}
                                    >
                                      <span
                                        className='btn btn-sm btn-icon btn-bg-light btn-active-color-primary'
                                        onClick={() => {
                                          onClickUnsubscribeHandler(key?.contactId ?? key?._id)
                                        }}
                                      >
                                        {key.contactId && isUnsubscribeLoading ? (
                                          <Spinner />
                                        ) : (
                                          AuthenticateUser('edit-contact') && (
                                            <i className='bi bi-person-fill-dash fs-5 text-danger'></i>
                                          )
                                        )}
                                      </span>
                                  </OverlayTrigger>
                              )}
                              <button
                                onClick={() => {
                                  setSelectedContactIDs([key?.contactId])
                                  setShowAddTagModal(true)
                                }}
                                style={{ backgroundColor: '#F6F8FA', color: '#A2A5B5' }}
                                className='btn btn-sm btn-light-primary  fw-500'
                              >
                                Add Tags
                              </button>
                            </div>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
            <div className='my-2'>
            <div className='card-label fw-bolder fs-2 mb-1 d-flex gap-2 align-items-center'>
              <div>Total Replies :</div>
              <span className='text-muted ml-2 mt-1 fw-bold'>
                {RepliesData?.data?.total}
              </span>
            </div>
            <div className='card-label fw-bolder fs-2 mb-1 d-flex gap-2 align-items-center'>
              <div>Total Responses :</div>
              <span className='text-muted ml-2 mt-1 fw-bold'>
                {RepliesData?.data?.totalResponse}
              </span>
            </div>
          </div>
          </div>
        ) : (
          <NodataYet message={'No replies yet'} />
        )}

        {RepliesData?.data?.items?.length > 0 && (
          <div className='abcd '>
            {/* <span>Total:</span> */}
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={RepliesData?.data?.totalPages}
              onPageChange={(e) => setSearch({ ...search, page: e.selected + 1 })}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </>
    )
  }

  const renderRegionData = () => {
    return (
      <>
        {messageListRegion?.data?.items?.length > 0 ? (
          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div className='table-responsive'>
                <table className='table align-middle gs-0 gy-5'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Mobile</th>
                      <th>First Name</th>
                      <th>Full Name</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Message</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {messageListRegion?.data?.items?.map((key: any, i: number) => {
                      return (
                        <tr key={i} className='border-dashed border-1 border-bottom'>
                          <td>{key?.metadata?.sender}</td>
                          <td>{key?.metadata?.sender_name ? key?.metadata?.sender_name : '-'}</td>
                          <td>{key?.metadata?.sender_name ? key?.metadata?.sender_name : '-'}</td>
                          <td>{moment(key?.created_at)?.format('l')}</td>
                          <td>{moment(key?.created_at)?.format('LT')}</td>

                          <td className='top-align'>
                            <div className='message-display'>{key?.metadata?.message || '-'}</div>
                            {key?.customerResponseMedia &&
                              Array.isArray(key.customerResponseMedia) &&
                              key.customerResponseMedia.length > 0 && (
                                <>
                                  <br />
                                  <Button
                                    size='sm'
                                    className='btm btn-sm mt-5'
                                    onClick={() => {
                                      setImageUrl(
                                        key.customerResponseMedia
                                          ? key.customerResponseMedia[0].url
                                          : ''
                                      )
                                      setShowImageModal(true)
                                    }}
                                  >
                                    Show Image
                                  </Button>
                                </>
                              )}
                          </td>
                          <td>
                            {key?.isReplied ? (
                              <button className='btn btn-sm btn-light-success btn-active-light-primary fw-500'>
                                Replied
                              </button>
                            ) : (
                              <button
                                onClick={() => {
                                  setNumber({ id: key?._id, number: key?.mobile, ReportId })
                                  setOpenQuickMessage(true)
                                }}
                                style={{ backgroundColor: '#F6F8FA', color: '#A2A5B5' }}
                                className='btn btn-sm btn-light-success  fw-500'
                              >
                                Reply
                              </button>
                            )}
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <NodataYet message={'No replies yet'} />
        )}

        {messageListRegion?.data?.items?.length > 0 && (
          <div className='abcd '>
            {/* <span>Total:</span> */}
            <ReactPaginate
              previousLabel='<'
              nextLabel='>'
              pageCount={messageListRegion?.data?.totalPages}
              onPageChange={(e) => setSearch({ ...search, page: e.selected + 1 })}
              containerClassName={'pagiantion'}
              previousLinkClassName={'pagination__link'}
              nextLinkClassName={'pagination__link'}
              disabledClassName={'pagination__link--disabled'}
              activeClassName={'pagination__link--active'}
            />
          </div>
        )}
      </>
    )
  }

  return (
    <>
      {ImagePreviewModal}
      {AuthenticateUser('send-quick-sms') && openQuickMessage && (
        <QuickMessageDrawerInner
          show={openQuickMessage}
          handleClose={() => setOpenQuickMessage(false)}
          CustomReplyReport={number}
          setCustomReplyReport={() => setNumber({ id: '', number: '', ReportId: '' })}
        />
      )}
      <div className='card mb-0 pt-7'>
        <div className='card-header align-items-center border-bottom-0'>
          <div className='card-header align-items-center border-bottom-0 w-100'>
            <h3 className='card-title align-items-start flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>All replies</span>
              <span className='text-muted mt-1 fw-bold fs-7'>
                See all your replies in one place
              </span>
            </h3>
            {isDefaultRegion && (
              <div className='d-flex align-items-center justify-content-end col-md-6 gap-2'>
                <div className='col-md-6'>
                  <Select
                    options={ContactStatusOptions}
                    onChange={(e) => {
                      setContactStatus(e?.value)
                      dispatch(
                        getCampaignReplies({
                          id: ReportId?.id,
                          params: { camp_type: ReportId?.camp_type, status: e?.value },
                        })
                      )
                    }}
                    className='col-md-2'
                  />
                </div>

                <button
                  onClick={() =>
                    dispatch(
                      getCampaignReplies({
                        id: ReportId?.id,
                        params: {
                          camp_type: ReportId?.camp_type,
                          exportData: true,
                          status: contactStatus,
                        },
                      })
                    )
                      .unwrap()
                      .then((res: any) => {
                        window.open(`${API_DOMAIN}${res?.data?.downloadurl}`, '_self')
                      })
                  }
                  type='button'
                  className='btn btn-light-primary me-3 ml-2'
                >
                  <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
                  Export
                </button>
              </div>
            )}
          </div>
        </div>

        {isDefaultRegion ? renderDefaultRegion() : renderRegionData()}
      </div>
    </>
  )
}

export default CustomerReplies
